import { components as coreComponents } from 'mage-core'
import * as R from 'ramda'
import React from 'react'
import { TitleSecondary } from 'mage-deps/@klarna/bubble-ui'
import { Message } from 'mage-i18n'
import OrientationItems from './OrientationItems'
import { useEducationFeature, EducationAnalytics } from 'education-tools'
import useOrientation from './hooks/useOrientation'
import useUnresolvedDisputesCount from '../Disputes/useUnresolvedDisputesCount'

function MerchantOrientationV2({ tokenHelper }) {
  const { data: pendingDisputes, isLoading: isLoadingDisputes } = useUnresolvedDisputesCount(
    tokenHelper
  )

  const orientationSlug =
    !isLoadingDisputes && pendingDisputes && pendingDisputes > 0
      ? 'merchant-orientation-v2-disputes'
      : 'merchant-orientation-v2'

  const { data: orientation, isLoading: isLoadingOrientation } = useOrientation(
    orientationSlug,
    tokenHelper
  )
  const isOrientationActive = useEducationFeature('meg.uhqm.orientation-v2')

  if (isLoadingDisputes || isLoadingOrientation || isOrientationActive === null) {
    return null
  }

  const showOrientation =
    isOrientationActive && orientation && orientation.orientationItems.length > 0

  if (showOrientation) {
    return (
      <>
        <EducationAnalytics
          category="orientation"
          action="print"
          label={orientationSlug}
          referenceId={orientation.id}
          referenceType="orientation"
        />
        <TitleSecondary>
          <Message path="orientation.title" fallback="Learn how to ..." />
        </TitleSecondary>
        <OrientationItems items={orientation.orientationItems} />
      </>
    )
  } else {
    return null
  }
}

export default R.compose(
  coreComponents.withTokenHelper(tokenHelper => ({
    tokenHelper
  }))
)(MerchantOrientationV2)
